import {bindState, pick, renderErrors, required, scrollToErrors} from '../utils';

/* eslint globals: ["countries"] */

export class RegisterForm extends React.Component {
    constructor(props) {
        super(props);

        this.bindState = bindState;

        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            email: null, first_name: null, last_name: null, company_name: null, phone: null,
            password: null, password_again: null, address: {}
        };
    }
    componentWillUnmount () {
        this.xhr && this.xhr.abort();
    }
    onSubmit (e) {
        e.preventDefault();
        var data = pick(this.state, 'email', 'first_name', 'last_name', 'company_name', 'phone', 'password', 'password_again', 'address');
        this.xhr = $.postJSON('/users/register', data).done(() => {
            window.location = '/users/registration_complete';
        }).fail((xhr, textStatus, errorThrown) => {
            if (xhr.status === 400) {
                this.setState(xhr.responseJSON, scrollToErrors)
            } else {
                this.setState({errors: {'_overall_': 'Operation failed.'}}, scrollToErrors)
            }
        }).always(() => this.xhr = null);
    }

    renderAddressErrors(address_field, field) {
        return renderErrors(this.state.errors && this.state.errors[address_field] && this.state.errors[address_field][field]);
    }

    renderAddressFields() {
        var address_field = 'address';
        var country = this.state[address_field].country;
        return (
            <div className={address_field + "-container"}>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor={address_field + "-country"} className="control-label">Country {required()}</label>
                            <select id={address_field + "-country"} className="form-control" value={country} onChange={this.bindState(address_field + '.country', v=> { this.state[address_field].subdivision = ''; return v;})}>
                                <option key="_" value=""></option>
                                { countries.map(c => <option key={c.code} value={c.code}>{c.name}</option>) }
                            </select>
                            {this.renderAddressErrors(address_field, 'country')}
                        </div>
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor={address_field + "-street1"} className="control-label">Address {required()}</label>
                    <input id={address_field + "-street1"} type="text" className="form-control" placeholder="Street Address" value={this.state[address_field].street1} onChange={this.bindState(address_field + '.street1')} />
                    {this.renderAddressErrors(address_field, 'street1')}
                </div>
                <div className="form-group">
                    <input id={address_field + "-street2"} type="text" className="form-control" placeholder="Apartment, suite, unit, etc. (optional) " value={this.state[address_field].street2} onChange={this.bindState(address_field + '.street2')} />
                    {this.renderAddressErrors(address_field, 'street2')}
                </div>
                <div className="form-group">
                    <label htmlFor={address_field + "-city"} className="control-label">City {required()}</label>
                    <input id={address_field + "-city"} type="text" className="form-control" placeholder="City" value={this.state[address_field].city} onChange={this.bindState(address_field + '.city')} />
                    {this.renderAddressErrors(address_field, 'city')}
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor={address_field + "-subdivision"} className="control-label">State / Province {required()}</label>
                            { /^(?:BR|CA|IT|MX|US)/.test(country || '') ?
                                <select id={address_field + "-subdivision"} className="form-control" value={this.state[address_field].subdivision} onChange={this.bindState(address_field + '.subdivision')}>
                                    <option key="_" value=""></option>
                                    { _states[country].map(ln => <option key={country + '-' + ln[0]} value={ln[0]}>{ln[1]}</option>) }
                                </select>
                                    :
                                    <input id={address_field + "-subdivision"} type="text" className="form-control" placeholder="State / Province" value={this.state[address_field].subdivision} onChange={this.bindState(address_field + '.subdivision')} />
                            }
                            {this.renderAddressErrors(address_field, 'subdivision')}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor={address_field + "-postal_code"} className="control-label">Postcode / ZIP {required()}</label>
                            <input id={address_field + "-postal_code"} type="text" className="form-control" placeholder="Postcode / ZIP" value={this.state[address_field].postal_code} onChange={this.bindState(address_field + '.postal_code')} />
                            {this.renderAddressErrors(address_field, 'postal_code')}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    render() {
        return (
            <div className="row">
                <div className="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2">
                    <h2>Sign Up</h2>
                    <hr />
                    {renderErrors(this.state.errors && this.state.errors._overall_)}
                    <form action="" method="POST" onSubmit={this.onSubmit}>
                        <h3>Please enter your details</h3>
                        <div className="form-group">
                            <label htmlFor="email">Email {required()}</label>
                            <input className="form-control" id="email" name="email" placeholder="Email" onChange={this.bindState('email')} />
                            {renderErrors(this.state.errors && this.state.errors.email)}
                        </div>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="form-group">
                                    <label htmlFor="first_name" className="control-label">First Name {required()}</label>
                                    <input id="first_name" type="text" className="form-control" placeholder="First Name" value={this.state.first_name} onChange={this.bindState('first_name')} />
                                    {renderErrors(this.state.errors && this.state.errors.first_name)}
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="form-group">
                                    <label htmlFor="last_name" className="control-label">Last Name {required()}</label>
                                    <input id="last_name" type="text" className="form-control" placeholder="Last Name" value={this.state.last_name} onChange={this.bindState('last_name')} />
                                    {renderErrors(this.state.errors && this.state.errors.last_name)}
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="company_name" className="control-label">Company Name</label>
                            <input id="company_name" type="text" className="form-control" placeholder="Company Name" value={this.state.company_name} onChange={this.bindState('company_name')} />
                            {renderErrors(this.state.errors && this.state.errors.company_name)}
                        </div>

                        <div className="form-group">
                            <label htmlFor="phone" className="control-label">Phone {required()}</label>
                            <input id="phone" type="text" className="form-control" placeholder="Phone" value={this.state.phone} onChange={this.bindState('phone')} />
                            {renderErrors(this.state.errors && this.state.errors.phone)}
                        </div>

                        <div className="form-group">
                            <label htmlFor="password">Password {required()}</label>
                            <input className="form-control" type="password" id="password" name="password" placeholder="Password" onChange={this.bindState('password')} />
                            {renderErrors(this.state.errors && this.state.errors.password)}
                        </div>
                        <div className="form-group">
                            <label htmlFor="password_again">Password confirmation {required()}</label>
                            <input className="form-control" type="password" id="password_again" name="password_again" placeholder="Enter the same password as before, for verification." onChange={this.bindState('password_again')} />
                            {renderErrors(this.state.errors && this.state.errors.password_again)}
                        </div>

                        <h3>Your main address</h3>
                        <p>This address will be used by default for both your billing and delivery address. It will be possible once registered to edit them.</p>
                        { this.renderAddressFields() }

                        <div className="form-group">
                            <button type="submit" className="btn btn-primary btn-lg pull-right" style={{'paddingLeft': 60, 'paddingRight': 60}}>SUBMIT</button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}
